import React from 'react';
import { Box, LinearProgress, Typography } from '@mui/material';

/**
 * 배치 변환 진행률 표시 컴포넌트
 */
const BatchProgressBar = ({ progress, total }) => {
  if (total === 0) return null;

  const percentage = (progress / total) * 100;

  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
        배치 변환 진행 중...
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <LinearProgress
          variant="determinate"
          value={percentage}
          sx={{ flex: 1, height: 8, borderRadius: 1 }}
        />
        <Typography variant="body2" sx={{ fontWeight: 600, minWidth: 60 }}>
          {progress} / {total}
        </Typography>
      </Box>
      <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block' }}>
        {percentage.toFixed(1)}% 완료
      </Typography>
    </Box>
  );
};

export default BatchProgressBar;
